// Jedinstvena pretraga ("Pretraga") iznad tabela.
//
// Korisnik kuca pojam, a padajuca lista nudi po jednu opciju za svaki tip
// pretrage koji stranica podrzava ("LBO: 123", "BZK: 123", ...). Izabrana opcija
// postaje "chip"; vise chipova se kombinuje (backend ih spaja sa AND), a po tipu
// moze postojati samo jedan chip.
//
// Dodavanje nove pretrage na stranicu = dodati kljuc tipa u PAGE_SEARCH_TYPES.
// Novi tip pretrage = dodati ga u SEARCH_TYPES (+ backend mora da podrzi param).

// Tipovi pretrage. `param` je query parametar koji backend vec podrzava na
// list endpointima (GET /therapies, /users, /therapies/saved, ...).
//   - userSearch:       ime/prezime pacijenta (po recima)
//   - lboSearch:        LBO, pocinje sa (prefix)
//   - bzkSearch:        broj zdravstvene knjizice, pocinje sa (prefix)
//   - phoneSearch:      telefon, sadrzi (substring)
//
// Lek NIJE deo ove pretrage: to je zaseban multiselect iz sifarnika lekova
// (MedicationFilterSelect, API param `medications`).
export const SEARCH_TYPES = {
  patient: { label: 'Pacijent', param: 'userSearch' },
  lbo: { label: 'LBO', param: 'lboSearch', digitsOnly: true },
  bzk: { label: 'BZK', param: 'bzkSearch' },
  phone: { label: 'Telefon', param: 'phoneSearch' },
};

// Koje pretrage nudi koja stranica (redosled = redosled opcija u listi).
export const PAGE_SEARCH_TYPES = {
  therapies: ['patient', 'lbo', 'bzk', 'phone'], // /terapije
  reservedTherapies: ['patient', 'lbo', 'bzk'], // /rezervisane-terapije
  savedTherapies: ['patient', 'lbo', 'bzk'], // /sacuvane-terapije
  users: ['patient', 'lbo', 'bzk', 'phone'], // /korisnici
  userActivityLogs: ['lbo'], // /korisnicke-izmene
};

export const getPageSearchTypes = (pageKey) =>
  (PAGE_SEARCH_TYPES[pageKey] || [])
    .filter((key) => SEARCH_TYPES[key])
    .map((key) => ({ key, ...SEARCH_TYPES[key] }));

const normalizeTerm = (type, term) => {
  const trimmed = (term || '').trim();
  return SEARCH_TYPES[type]?.digitsOnly ? trimmed.replace(/\D/g, '') : trimmed;
};

// [{ type: 'lbo', term: '123' }, ...] -> { lboSearch: '123', ... }
// Svi parametri stranice su uvek prisutni (prazan string kada nisu aktivni),
// da bi ih stranica mogla direktno da destrukturira.
export const buildSearchParams = (pageKey, entries) => {
  const params = {};
  getPageSearchTypes(pageKey).forEach(({ param }) => {
    params[param] = '';
  });
  (entries || []).forEach(({ type, term }) => {
    const config = SEARCH_TYPES[type];
    if (config) params[config.param] = normalizeTerm(type, term);
  });
  return params;
};
